<script context="module"></script>

<script>export let language;
export let code;
export let langtag = false;
import hljs from "highlight.js/lib/core";
import { createEventDispatcher, afterUpdate } from "svelte";
import LangTag from "./LangTag.svelte";
const dispatch = createEventDispatcher();
let highlighted = "";
afterUpdate(() => {
  if (highlighted)
    dispatch("highlight", { highlighted });
});
$: {
  hljs.registerLanguage(language.name, language.register);
  highlighted = hljs.highlight(code, { language: language.name }).value;
}
</script>

<slot {highlighted}>
  <LangTag
    {...$$restProps}
    languageName={language.name}
    {langtag}
    {highlighted}
    {code}
  />
</slot>
